module.exports = __webpack_public_path__ + "static/media/404.8e304055.gif";